import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const costCenterTypeModURL = "api/v1/cost-center/cost-center-type";

//obtaining the paginated data
export const getCostCenterType = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${costCenterTypeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllCostCenterType = () => axiosInstance.get(`${costCenterTypeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCostCenterType = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${costCenterTypeModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createCostCenterType = (body) => axiosInstance.post(`${costCenterTypeModURL}/create`, body);
//updating function
export const updateCostCenterType = (id, body) => axiosInstance.patch(`${costCenterTypeModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(
    `${costCenterTypeModURL}/list?offset=0&limit=${rowsPerPage} &ordering=${sortOrder} &search=${search}`
  );

// checking the redundant data
export const checkRedundantDataCostCenterTypeName = (e, cancelToken) =>
  axiosInstance.get(`${costCenterTypeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
